import React from 'react';

function DownArrowIcon({ className = '' }) {
	return (
		<svg
			className={className}
			width='20'
			height='20'
			viewBox='0 0 20 20'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<path
				d='M5.8335 7.91718L10.0002 12.0838L14.1668 7.91718H5.8335Z'
				fill='#545454'
			/>
		</svg>
	);
}

export default DownArrowIcon;
